import * as React from 'react';
import { storyblokEditable } from 'gatsby-source-storyblok';

export default function LinkList({ blok }) {
  if (!blok.links) {
    return null;
  }

  return (
    <div
      {...storyblokEditable(blok)}
      className="pt-20 lg:pt-36 max-w-fit mx-auto px-4 lg:px-16 "
    >
      {blok.links.map((link, index) => {
      const url = link.link?.cached_url || link.link?.url || '#';
      return (
          <a
            href={url}
            title={link.link?.link_title || undefined}
            key={`link-${index}`}
            className="inline-block px-4 py-2 font-bold"
          >
            {link.LinkText}
          </a>
        );
      })}
    </div>
  );
}
